export const relatorioConfig = {
    2: {
        nome: "Relatório Acompanhamento Consolidado Mensal",
        toRender: [
            {
                type: "mes",
                label: "Mês",
                name: "mesReferencia",
                extraProps: { getUltimoDia: false }
            }
        ]
    },
    4: {
        nome: "Relatório Acompanhamento Consolidado Mensal",
        toRender: [
            {
                type: "mes",
                label: "Data Inicio",
                name: "dataInicio",
                extraProps: { getUltimoDia: false }
            },
            {
                type: "mes",
                label: "Data Fim",
                name: "dataFim",
                extraProps: { getUltimoDia: true }
            }
        ]
    },
    5: {
        nome: "Relatório Acompanhamento Consolidado Trimestral",
        toRender: [
            {
                type: "mes",
                label: "Data Inicio",
                name: "dataInicio",
                extraProps: { getUltimoDia: false }
            },
            {
                type: "mes",
                label: "Data Fim",
                name: "dataFim",
                extraProps: { getUltimoDia: true }
            }
            
        ]
    },
    6: {
        nome: "Pendências Trimestrais XLSX",
        toRender: [
            {
                type: "mes",
                label: "Data Inicio",
                name: "dataInicio",
                extraProps: { getUltimoDia: false }
            },
            {
                type: "mes",
                label: "Data Fim",
                name: "dataFim",
                extraProps: { getUltimoDia: true }
            }
        ]
    },
    7: {
        nome: "Relatório Acompanhamento Consolidado Mensal (Capa)",
        toRender: [
            {
                type: "mes",
                label: "Mês",
                name: "mesReferencia",
                extraProps: { getUltimoDia: false }
            }
        ]
    },
    8: {
        nome: "Indicadores por Métrica",
        toRender: [
            {
                type: "select",
                label: "Indicador",
                name: "metricaCodigo"
            },
            {
                type: "mes",
                label: "Data Inicio",
                name: "dataInicio",
                extraProps: { getUltimoDia: false }
            },
            {
                type: "mes",
                label: "Data Fim",
                name: "dataFim",
                extraProps: { getUltimoDia: true }
            }
        ]
    },
    9: {
        nome: "Quadro de Inconformidades",
        toRender: [
            {
                type: "mes",
                label: "Data Inicio",
                name: "dataInicio",
                extraProps: { getUltimoDia: false }
            },
            {
                type: "mes",
                label: "Data Fim",
                name: "dataFim",
                extraProps: { getUltimoDia: true }
            }
        ]
    }
}